import { createPinia, type Pinia } from 'pinia';
import type { App } from 'vue';
import { Quasar } from 'quasar';
import { setupQuasar } from '@/config/quasar';
import { i18n } from './i18n';

// Create shared plugin instances that can be reused across multiple Vue app instances
export const sharedPinia: Pinia = createPinia();
export const sharedI18n = i18n;
export const sharedQuasarConfig = setupQuasar();

// Helper function to set up plugins on a Vue app instance
export function setupAppPlugins(app: App) {
  app.use(sharedPinia);
  app.use(sharedI18n);
  app.use(Quasar, sharedQuasarConfig);
}
